import React, {Component} from 'react';
import {Badge,Row, Col, Card, CardHeader, CardBody, Button, CardFooter} from 'reactstrap';
import {NavLink,Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';

class StoryCreatingPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      email:"",
      password:"",
      storeStoryboards:[],
      isLoading: false,
      errorModalOpen: false,
      storeProjectCode:"",
      liveStoryboards:[],
      liveProjectCode:"",
      devStoryboards:[],
      devProjectCode:"",
      customerType: ""
    };
    this.redirectRequest = this.redirectRequest.bind(this);
  }

  redirectRequest() {
    this.setState({
      navigate: true,
      path:'storyCreating/StoryRequest'
    })

  }


  componentWillMount() {

      if(!this.props.user.isLoggedIn) {
          this.setState({
            path:"login",
            navigate:true

          })
        }
      let id = parseInt(this.props.match.params.Id);
      let authToken = this.props.user.authToken;
      let cId = this.props.user.customerId;


     $.ajax({
          url: `https://screen.mobflic.com/v1/current-user/projects`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {

            for (var i=0;i<res.result.projects.length;i++)
            {
                if (res.result.projects[i].projectType == "Store") {
                  this.setState({storeProjectCode:res.result.projects[i].code});

                  let id = res.result.projects[i].id;
                  $.ajax({
                      url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards`,
                      type: 'GET',
                      beforeSend: function (xhr) {
                              xhr.setRequestHeader ("X-Auth-Token",authToken);
                      },
                      success: (res) => {
                        let storeStoryboards = [];
                        for (var j=0;j<res.result.length;j++){
                          if(res.result[j].projectId == id) {
                            storeStoryboards.push(res.result[j]);
                          }
                        }
                        console.log(storeStoryboards);
                        this.setState({storeStoryboards:storeStoryboards},()=>console.log(this.state.storeStoryboards))

                      },
                      error: (res,a,b) => {
                          console.log(res);
                      }


                  });
                };
            }
           console.log(res);
         },
        error: (res,a,b) => {
            console.log(res);
        }

      });

      //V2

      $.ajax({
        url: `https://screen.mobflic.com/v1/current-user/projects`,
        type: 'GET',
        beforeSend: function (xhr) {
                xhr.setRequestHeader ("X-Auth-Token",authToken);
        },
        success: (res,a,b) => {

          for (var i=0;i<res.result.projects.length;i++)
          {
              if (res.result.projects[i].projectType == "Dev") {
                this.setState({

                  devProjectCode:res.result.projects[i].code
                })
                let id = res.result.projects[i].id;
                $.ajax({
                    url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards`,
                    type: 'GET',
                    beforeSend: function (xhr) {
                            xhr.setRequestHeader ("X-Auth-Token",authToken);
                    },
                    success: (res) => {
                      let devStoryboards = [];
                      for (var j=0;j<res.result.length;j++){
                        if(res.result[j].projectId == id) {
                          devStoryboards.push(res.result[j]);
                        }
                      }
                      this.setState({devStoryboards:devStoryboards})
                    },
                    error: (res,a,b) => {
                        console.log(res);
                    }


                });
              };
          }
       },
      error: (res,a,b) => {
          console.log(res);
      }

    });


   $.ajax({
        url: `https://screen.mobflic.com/v1/current-user/projects`,
        type: 'GET',
        beforeSend: function (xhr) {
                xhr.setRequestHeader ("X-Auth-Token",authToken);
        },
        success: (res,a,b) => {

          for (var i=0;i<res.result.projects.length;i++)
          {
              if (res.result.projects[i].projectType == "Live") {
                 this.setState({
                  liveProjectCode:res.result.projects[i].code
                })
                let id = res.result.projects[i].id;
                $.ajax({
                    url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards`,
                    type: 'GET',
                    beforeSend: function (xhr) {
                            xhr.setRequestHeader ("X-Auth-Token",authToken);
                    },
                    success: (res) => {
                      let liveStoryboards = [];
                      for (var j=0;j<res.result.length;j++){
                        if(res.result[j].projectId == id) {
                          liveStoryboards.push(res.result[j]);
                        }
                      }
                      console.log(liveStoryboards);
                      this.setState({liveStoryboards:liveStoryboards},()=>console.log(this.state.liveStoryboards))

                    },
                    error: (res,a,b) => {
                        console.log(res);
                    }


                });
              };
          }
       },
      error: (res,a,b) => {
          console.log(res);
      }

    });

    $.ajax({
         url: `https://screen.mobflic.com/v1/current-user`,
         type: 'GET',
         beforeSend: function (xhr) {
                 xhr.setRequestHeader ("X-Auth-Token",authToken);
         },
         success: (res) => {
           this.setState({
             customerType:res.result.customerType
           })
        },
       error: (res,a,b) => {
           console.log(res);
       }

     });

     //V2 

    }


  render() {

     const { navigate, path } = this.state

      // here is the important part
      if (navigate) {
        console.log(path);
        return <Redirect to={ "/" + path } push={true} />
      }

    return (

      <div className="animated fadeIn">
        <Row>

           <Col xs="3" >
              <Button style={{width:"200px", "borderRadius":"5px"}} onClick={()=>this.redirectRequest()} color="primary">Request Storyboard</Button>
           </Col>

        </Row>
        <Row style={{marginTop:"20px"}}>
          <Col xs="12" >
            <Card>
              <CardHeader>
                <i  className="fa fa-thumbs-up fa-lg mt-2" ></i>   <strong>  Recommended for you   </strong> <Badge color="success"> { this.state.storeProjectCode } </Badge>
              </CardHeader>

              <CardBody>
                <Row>
                  {
                  this.state.storeStoryboards.map((item) => {

                  return (
                    <Col xs="12" sm="6" md="4">
                     <Card>
                        <CardHeader>
                          {item.title}
                        </CardHeader>
                        <CardBody style={{backgroundColor:"#00FFFF",height:"166px",padding:"0"}}>
                        {
                          item.landScapeImageAssetId?
                          <img style={{"height":"100%","width":"100%","display":item.landScapeImageAssetId.length>0?"":"none"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(item.landScapeImageAssetId) + "?storyboardId=" + item.id + "&authToken=" + this.props.user.authToken} />
                          :null
                        }
                        </CardBody>
                        <CardFooter style={{textAlign:"center"}} >  <NavLink to={"/storyCreating/details/"+item.id}> <i className="fa fa-eye fa-lg mt-2"></i> More Details  </NavLink>  </CardFooter>
                      </Card>
                    </Col>
                    )

                  })
                }

                </Row>
                </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )

  }
}

function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}


export default connect(mapStateToProps)(StoryCreatingPage);



// WEBPACK FOOTER //
// ./src/views/Components/StoryCreating/storyCreating.js